// NodeCoverService.js

// Firebase
import { functions, httpsCallable } from 'firebaseConfig';
import { buildTenantCallableFields } from 'utilities/basePersistence';

const SAVE_NODE_COVER_FN = 'saveNodeCover';
const REMOVE_NODE_COVER_FN = 'removeNodeCover';

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = typeof reader.result === 'string' ? reader.result : '';
      if (!result) {
        reject(new Error('Failed to read image data.'));
        return;
      }

      resolve(result);
    };

    reader.onerror = () => {
      reject(new Error('Failed to read image data.'));
    };

    reader.readAsDataURL(blob);
  });
}

export async function saveNodeCover({ nodeKey, baseKey, file }) {
  const cleanedNodeKey = String(nodeKey || '').trim();
  const cleanedBaseKey = String(baseKey || '').trim();

  if (!cleanedNodeKey || !cleanedBaseKey) {
    throw new Error('Node key and base key are required.');
  }

  if (!(file instanceof Blob)) {
    throw new Error('An image file is required.');
  }

  const dataUrl = await blobToDataUrl(file);
  const call = httpsCallable(functions, SAVE_NODE_COVER_FN);
  const { data } = await call({
    contentType: String(file.type || '').trim() || 'image/jpeg',
    dataUrl,
    fileName: String(file.name || 'cover').trim() || 'cover',
    fileSizeBytes: Number(file.size || 0),
    nodeKey: cleanedNodeKey,
    ...buildTenantCallableFields(cleanedBaseKey),
  });

  return data || null;
}

export async function removeNodeCover({ nodeKey, baseKey }) {
  const cleanedNodeKey = String(nodeKey || '').trim();
  const cleanedBaseKey = String(baseKey || '').trim();

  if (!cleanedNodeKey || !cleanedBaseKey) {
    throw new Error('Node key and base key are required.');
  }

  const call = httpsCallable(functions, REMOVE_NODE_COVER_FN);
  const { data } = await call({
    nodeKey: cleanedNodeKey,
    ...buildTenantCallableFields(cleanedBaseKey),
  });

  return data || null;
}
